import { TransactionDetails, notifyDetails } from "../types/api.types";

// paymentActions.ts
export const SET_NOTIFY_DETAILS = 'SET_NOTIFY_DETAILS';

export const setNotifyDetails = (payload: notifyDetails) => ({
  type: SET_NOTIFY_DETAILS,
  payload,
});
